import React, { useEffect, useState } from 'react';
import { callcenterService } from '../../api/callcenterService';
import { Card, CardHeader, CardTitle, CardContent, Button } from '../ui';
import toast from 'react-hot-toast';

const QueueStatus = () => {
  const [statusText, setStatusText] = useState('');
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const txt = await callcenterService.getQueueStatus();
      setStatusText(txt || '');
    } catch (e) {
      console.error(e);
      toast.error('Failed to load status');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>Queue Status (Raw)</CardTitle>
            <Button onClick={load} disabled={loading}>
              {loading ? 'Refreshing...' : 'Refresh'}
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <pre className="bg-black text-green-200 p-4 rounded overflow-x-auto whitespace-pre-wrap">
{statusText}
          </pre>
        </CardContent>
      </Card>
    </div>
  );
};

export default QueueStatus;

